import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const SubscriptionPage = loadAsyncComponent(() => import('./Container'), 'page');
